import React from 'react';

import Button from 'components/form/Button';
import Card from 'components/Layout/Card';

import { icons } from 'utils/constants';
import usePermission from 'hooks/usePermission';

const EmailPreview = ({ template, onEdit, onHistory }) => {
  const { trigger_on, subject, status, from, to, body } =
    template;
  const { viewAccess, updateAccess } = usePermission("Email Templates");
  const StatusBadge = () =>
    status === 1 ? (
      <div className="cps-8 cpt-3 cpb-3 cpe-8 text-12-500-15 br-4 color-text-blue bg-eff3 b-text-blue">
        Enabled
      </div>
    ) : (
      <div className="cps-8 cpt-3 cpb-3 cpe-8 text-12-500-15 br-4 color-6866 bg-F3F4F8 b-6866">
        Disabled
      </div>
    );

  return (
    <Card className="cp-20 h-100">
      {/* Trigger Flow */}
      <div className="row cmt-49">
        <div className="col-12 text-14-400-18 color-text-blue cpb-8">
          Trigger Flow :
        </div>
        <div className="col-12 text-14-400-24">{trigger_on || '-'}</div>
      </div>

      {/* From, To, Template Status */}
      <div className="row cmt-20">
        <div className="col-md-4 col-12 text-14-400-18 color-text-blue cpb-8">
          From :
        </div>
        <div className="col-md-4 col-12 text-14-400-18 color-text-blue cpb-8">
          To :
        </div>
        <div className="col-md-4 col-12 text-14-400-18 color-text-blue cpb-8">
          Template Status :
        </div>

        <div className="col-md-4 col-12 text-14-400-24">{from || '-'}</div>
        <div className="col-md-4 col-12 text-14-400-24">{to || '-'}</div>
        <div className="col-md-4 col-12 text-14-400-24 d-flex">
          <StatusBadge />
        </div>
      </div>

      {/* Email Subject */}
      <div className="row cmt-20">
        <div className="col-12 text-14-400-18 color-text-blue cpb-8">
          Email Subject :
        </div>
        <div className="col-12 text-14-400-24">{subject || '-'}</div>
      </div>

      {/* Email Body */}
      <div className="row cmt-20">
        <div className="col-12 text-14-400-18 color-text-blue cpb-8">
          Email Body :
        </div>
        <div className="col-12">
          <div
            style={{ width: "100%" }}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </div>
      </div>


      {/* Actions */}
      <div className="cmt-20 d-flex gap-2">
        {updateAccess === "1" &&
          <Button
            icon={
              <img
                src={icons.Edit}
                alt=""
                style={{ filter: 'brightness(0) invert(1)', marginRight: '8px' }}
                height={18}
                width={18}
              />
            }
            btnStyle="primary-dark"
            className="cps-15 cpe-15 h-37"
            text="Edit Template"
            onClick={onEdit}
          />}
        {viewAccess === "1" &&
          <Button
            icon={
              <span className="me-2">
                <img src={icons.historyLightIcon} alt="" height={18} width={18} />
              </span>
            }
            btnStyle="primary-outline1"
            className="cps-15 cpe-15 h-37"
            text="History"
            onClick={onHistory}
          />}
      </div>
    </Card>
  );
};

export default EmailPreview;
